function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getAcceptableCountries } from "../../StudentOnboarding/storage/Countries/localStorage";
import { getStoredProgramLevelFamily } from "../../StudentOnboarding/storage/ProgramLevelFamilies/localStorage";
import { Keys } from "../Common/Constants";
import { askForStandardizedTests } from "./Helper";
import { assert } from "../../../utils/assert";
export var formatRegisterPayload = function formatRegisterPayload(data) {
  var formatData = _objectSpread({}, data);
  if ('country_names' in formatData) delete formatData.country_names;
  if ('categories' in formatData) delete formatData.categories;
  if ('sub_categories' in formatData) delete formatData.sub_categories;
  return formatData;
};
export var setRegisterURL = function setRegisterURL(redirectPath, data) {
  window.location.assign("\n    ".concat(window.location.origin, "/register?redirect_to=").concat(redirectPath, "&profile=").concat(JSON.stringify(formatRegisterPayload(data)), "&signup_source=cef\n  "));
};
export var applyAction = function applyAction(programId, userId, searchData) {
  var searchParams = new URLSearchParams({
    program_id: programId
  });
  var applyURL = "/apply_program?".concat(searchParams.toString());
  if (userId) window.location.assign("".concat(window.location.origin).concat(applyURL));else setRegisterURL(applyURL, searchData);
};
var formatEnglishTest = function formatEnglishTest(test) {
  return (test === null || test === void 0 ? void 0 : test.value) === '' ? null : test;
};
function formatCountries(countryCodes, markets) {
  // Because Search sucks, it uses names like "Canada" instead of codes like "CA"
  return countryCodes.map(function (code) {
    return countryCodeToName(markets, code);
  });
}
function countryCodeToName(markets, code) {
  var market = markets.find(function (market) {
    return market.id === code;
  });
  assert(market, "Could not find market for code ".concat(code));
  return market.commonName;
}
function formatProgramLevels(programLevels, educationLevels, educationLevelFamilyTypes) {
  var families = educationLevelFamilyTypes.map(function (family) {
    if (programLevels.includes(family.id)) return family.key;
  });
  var levels = [];
  families.forEach(function (family) {
    return educationLevels.forEach(function (level) {
      if (level.family === family) levels.push(level.key);
    });
  });
  return levels;
}
function formatFieldsOfEducation(studentPreferences, fieldsOfEducationData) {
  var categories = [];
  var subCategories = [];

  // we need to get the categories subCategories from preferences
  if (studentPreferences !== null && studentPreferences !== void 0 && studentPreferences.fieldOfEducation) {
    studentPreferences.fieldOfEducation.forEach(function (value) {
      // the preferences returns the values in one list mixing categories and subcategories
      // so check the fieldsOfEducation hook, top level are all categories
      if (fieldsOfEducationData !== null && fieldsOfEducationData !== void 0 && fieldsOfEducationData.find(function (category) {
        return category.name === value.toString();
      })) {
        categories.push(value);
      } else {
        subCategories.push(value);
      }
    });
  }
  return {
    categories: categories,
    subCategories: subCategories
  };
}
export var formatPayload = function formatPayload(application, markets, marketPreferences, studentPreferences, educationLevels, educationLevelFamilyTypes, fieldsOfEducationData) {
  var _nationality$code, _countryOfResidence$c, _application$educatio, _application$educatio2, _application$educatio3, _application$mostRece, _application$mostRece2, _application$mostRece3, _application$mostRece4, _application$mostRece5, _application$mostRece6, _studentPreferences$i, _studentPreferences$b, _application$stateOfR;
  var country_codes = getAcceptableCountries();
  var country_names = formatCountries(country_codes, markets);
  var eng_test = formatEnglishTest(application[Keys.Application.englishProficiencyTest]);
  var nationality = application[Keys.Application.nationality];
  var countryOfResidence = application[Keys.Application.countryOfResidence];
  var formattedMarkets = marketPreferences ? formatCountries(marketPreferences, markets) : [];
  var formattedProgramLevels = studentPreferences && educationLevels && educationLevelFamilyTypes ? formatProgramLevels(studentPreferences.programLevelFamily, educationLevels, educationLevelFamilyTypes) : [];
  var _formatFieldsOfEducat = formatFieldsOfEducation(studentPreferences, fieldsOfEducationData),
    categories = _formatFieldsOfEducat.categories,
    subCategories = _formatFieldsOfEducat.subCategories;
  var data = _objectSpread({
    must_save_residency: 't',
    nationality: (_nationality$code = nationality === null || nationality === void 0 ? void 0 : nationality.code) !== null && _nationality$code !== void 0 ? _nationality$code : '',
    country_of_residency: (_countryOfResidence$c = countryOfResidence === null || countryOfResidence === void 0 ? void 0 : countryOfResidence.code) !== null && _countryOfResidence$c !== void 0 ? _countryOfResidence$c : '',
    education_country: (_application$educatio = (_application$educatio2 = application.educationCountry) === null || _application$educatio2 === void 0 ? void 0 : _application$educatio2.code) !== null && _application$educatio !== void 0 ? _application$educatio : '',
    graduated: application.educationStatus === 'Graduated',
    studied_level: (_application$educatio3 = application.educationType) !== null && _application$educatio3 !== void 0 ? _application$educatio3 : '',
    grading_scheme: (_application$mostRece = (_application$mostRece2 = application.mostRecentOverallGrade) === null || _application$mostRece2 === void 0 ? void 0 : _application$mostRece2.gradingSchemeId) !== null && _application$mostRece !== void 0 ? _application$mostRece : 0,
    grade: (_application$mostRece3 = (_application$mostRece4 = application.mostRecentOverallGrade) === null || _application$mostRece4 === void 0 ? void 0 : _application$mostRece4.grade) !== null && _application$mostRece3 !== void 0 ? _application$mostRece3 : '',
    grade_scale: (_application$mostRece5 = (_application$mostRece6 = application.mostRecentOverallGrade) === null || _application$mostRece6 === void 0 ? void 0 : _application$mostRece6.gradeMax) !== null && _application$mostRece5 !== void 0 ? _application$mostRece5 : '',
    // We need both, country names and codes, b/c filters on search page uses country_names
    // while the payload returned by useSchoolEligibilityApi also needs the codes.
    // The payload from useSchoolEligibilityApi is passed to the Program Page and is used to generate
    // the register url.
    country_names: country_names,
    country_codes: country_codes,
    program_level_families: getStoredProgramLevelFamily(),
    countries: formattedMarkets,
    program_level: formattedProgramLevels,
    // categories and sub_categories are used for quick_search filters but fields_of_education
    // is used in the register profile payload
    categories: categories,
    sub_categories: subCategories,
    fields_of_education: [].concat(_toConsumableArray(categories), _toConsumableArray(subCategories)),
    intakes: (_studentPreferences$i = studentPreferences === null || studentPreferences === void 0 ? void 0 : studentPreferences.intakes) !== null && _studentPreferences$i !== void 0 ? _studentPreferences$i : [],
    budget: (_studentPreferences$b = studentPreferences === null || studentPreferences === void 0 ? void 0 : studentPreferences.budget) !== null && _studentPreferences$b !== void 0 ? _studentPreferences$b : '',
    province_of_residency: (_application$stateOfR = application.stateOfResidence) === null || _application$stateOfR === void 0 ? void 0 : _application$stateOfR.name,
    eng_test: eng_test !== null && eng_test !== void 0 ? eng_test : undefined
  }, askForStandardizedTests(application[Keys.Application.degree]) ? {
    gre: application[Keys.Application.greTest],
    gmat: application[Keys.Application.gmatTest]
  } : {});
  return data;
};